import React from "react"

// setFieldValue
import { Field } from "formik"

const Select = ({ name, label, options, className, ...props }) => {
	return (
		<div className={`w-full ${className || ""}`}>
			<div className="bg-white w-full h-60 px-20 border border-iron focus-within:border-pictonblue hover:border-jetblack hover:focus-within:border-pictonblue flex flex-col justify-center rounded-medium">
				<Field name={name}>
					{({ field, form, meta }) => (
						<div className="relative">
							<select
								{...field}
								className={`w-full p-0 m-0 border-none transition-all bg-transparent outline-none  appearance-none text-base peer focus:ring-0 focus:ring-offset-0 ${
									field.value !== "none"
										? "text-jetblack opacity-100 mt-[19px]"
										: "text-nevada opacity-50 mt-[0px]"
								}`}>
								{options.map((option, index) => (
									<option
										key={`select-${name}-${index}`}
										value={option.value}
										{...(option.options || null)}>
										{option.text}
									</option>
								))}
							</select>
							{field.value !== "none" && (
								<label
									htmlFor={name}
									className="p-0 m-0 text-nevada transition-all absolute left-0 text-xs peer-placeholder-shown:text-base peer-focus:text-xs opacity-90 peer-focus:opacity-90 peer-placeholder-shown:opacity-50">
									{label}
								</label>
							)}
						</div>
					)}
				</Field>
			</div>
		</div>
	)
}

export default Select
